import { HTMLProps } from "react";
import styled from "styled-components";

export const ListItemText = styled.div`
  width: 100%;
  min-height: 96px;
  margin-bottom: 1px;
  display: flex;
  font-size: 1.8rem;
  font-family: "Roboto";
  padding: 0 1.6rem;
  border-radius: 10px;
  margin-top: 1.6rem;
  transition: background-color 0.3s ease-in;
  background-color: white;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 1366px) {
    min-height: 78px;
  }
`;
